var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-link",
    {
      staticClass: "opt-group",
      staticStyle: { "font-size": "12px" },
      attrs: { type: "primary" },
      on: { click: _vm.handleVesselCode },
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.record.vesselName) +
          " " +
          _vm._s(_vm.record.voyageNo) +
          _vm._s(_vm.record.voyageLeg) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }